/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodBundlesTableColumnEnum {
    NUMBER = 'NUMBER',
    STATUS = 'STATUS',
    TOTAL_GROSS_COST = 'TOTAL_GROSS_COST',
    LINES_QUANTITY = 'LINES_QUANTITY',
    TOTAL_COST_PROGRESS = 'TOTAL_COST_PROGRESS',
    CLOSED_BY = 'CLOSED_BY',
    CLOSED_ON = 'CLOSED_ON',
    SENT = 'SENT',
    TOTAL_SETTLEMENTS = 'TOTAL_SETTLEMENTS',
    TOTAL_NET_AMOUNT = 'TOTAL_NET_AMOUNT'
}
